import { configureStore } from '@reduxjs/toolkit';

const registerState = (state = {}, action) => {
    switch (action.type) {
        case 'REGISTER_FIELD_CHANGE':

            var newObj = {
                models: []
            };

            if (state.models) {
                newObj.models = state.models;
            }

            switch (action.field) {
                case 'payment_transfer_bank':
                    newObj.payment = {};
                    newObj.type = 1;
                    newObj.payment.bank = action.value;
                    newObj.payment.account = state.payment ? state.payment.account : '';
                    newObj.payment.clearing = state.payment ? state.payment.clearing : '';
                    break;
                case 'payment_transfer_account':
                    newObj.payment = {};
                    newObj.type = 1;
                    newObj.payment.account = action.value;
                    newObj.payment.clearing = state.payment ? state.payment.clearing : '';
                    newObj.payment.bank = state.payment ? state.payment.bank : '';
                    break;
                case 'payment_transfer_clearing':
                    newObj.payment = {};
                    newObj.type = 1;
                    newObj.payment.clearing = action.value;
                    newObj.payment.bank = state.payment ? state.payment.bank : '';
                    newObj.payment.account = state.payment ? state.payment.account : '';
                    break;
                default:
                    newObj[action.field] = action.value;
                    break;
            }

            if (action.index >= 0) {
                var model = {

                };
                if (newObj.models[action.index]) {
                    model = newObj.models[action.index];
                }
                switch (action.field) {
                    case 'email':
                        model.email = action.value;
                        break;
                    case 'ssn':
                        model.ssn = action.value;
                        break;
                    case 'name':
                        model.name = action.value;
                        break;
                    case 'address':
                        model.address = action.value;
                        break;
                    case 'postal_code':
                        model.postal_code = action.value;
                        break;
                    case 'city':
                        model.city = action.value;
                        break;
                    case 'phone':
                        model.phone = action.value;
                        break;
                    case 'profile':
                        model.profile = action.value;
                        break;
                    case 'description':
                        model.description = action.value;
                        break;
                }
                newObj.models = newObj.models.slice(0, action.index).concat([model]).concat(newObj.models.slice(action.index + 1));
            }

            return Object.assign({}, state, newObj);
        case 'SET_REGISTER_EVENT':
            return Object.assign({}, state,  {
                eula: action.eula,
                event: action.event,
                compensation: action.compensation,
                company: action.company,
                registerType: 1
            });
        case 'SET_REGISTER_STATUS':
            return Object.assign({}, state,  {
                status: action.status
            });
        case 'REGISTER_OPEN_STEP_2':
            return Object.assign({}, state,  {
                showStep2: true,
                invalidSSNEmail: false,
                models: [{
                    ssn: state.ssn,
                    email: state.email,
                    description: ''
                }]
            });

        case 'REGISTER_TYPE':
            return Object.assign({}, state,  {
                registerType: action.registerType
            });
        case 'REGISTER_TERMS':
            return Object.assign({}, state,  {
                terms: !state.terms
            });
        case 'MODEL_RECEIVED':

            var models = [];
            if (state.models) {
                models = state.models;
            }

            action.model.ssn = state.ssn;
            models = [action.model];

            return Object.assign({}, state,  {
                models: models,
                name: action.model.name,
                address: action.model.address,
                postal_code: action.model.postal_code,
                city: action.model.city,
                email: action.model.email,
                phone: action.model.phone,
                profile: action.model.profile,
                showStep2: true,
                invalidSSNEmail: false,
                invalidAge: false
            });
        case 'REGISTER_COMPLETE':
            return Object.assign({}, state,  {
                models: [],
                invalidData: [],
                showStep3: true
            });
        case 'REGISTER_INVALID':
            return Object.assign({}, state,  {
                invalid: true,
                invalidUnknown: false,
                invalidData: action.data
            });
        case 'REGISTER_INVALID_UNKNOWN':
            return Object.assign({}, state,  {
                invalidUnknown: true,
                errorCode: action.errorCode
            });
        case 'REGISTER_INVALID_AGE':
            return Object.assign({}, state,  {
                invalidAge: true,
                invalidSSNEmail: false
            });
        case 'REGISTER_INVALID_SSN':
            return Object.assign({}, state,  {
                invalidSSNEmail: true,
                invalidAge: false
            });
        default:
            return state;
    }
}

const registerModelState  = (state = {}, action) => {
    switch (action.type) {
        case 'REGISTER_MODEL_FIELD_CHANGE':

            var newObj = {};

            switch (action.field) {
                case 'ssn':
                    newObj.ssn = action.value;
                    break;
                case 'name':
                    newObj.name = action.value;
                    break;
                case 'email':
                    newObj.email = action.value;
                    break;
                case 'phone':
                    newObj.phone = action.value;
                    break;
                case 'address':
                    newObj.address = action.value;
                    break;
                case 'postal_code':
                    newObj.postal_code = action.value;
                    break;
                case 'city':
                    newObj.city = action.value;
                    break;
                case 'image':
                    newObj.image = action.value;
                    break;
                case 'description':
                    newObj.description = action.value;
                    break;
            }

            return Object.assign({}, state, newObj);
        case 'REGISTER_MODEL_COMPLETE':
            return Object.assign({}, state, {
                status: 1
            });
        case 'REGISTER_MODEL_TERMS':
            return Object.assign({}, state,  {
                terms: !state.terms
            });
        case 'REGISTER_MODEL_INVALID':
            return Object.assign({}, state,  {
                invalid: true,
                invalidUnknown: false,
                invalidData: action.data,
                invalidStatus: action.status
            });
        default:
            return state;
    }
}


const sinceState = (state = {}, action) => {
    switch (action.type) {
        case 'SINCE_CONTRACT_RECEIVED':
            return Object.assign({}, state,  {
                contracts: action.contracts
            });
        default:
            return state;
    }
}

const pageState  = (state = {}, action) => {
    switch (action.type) {
        case 'SET_PAGE':
            return Object.assign({}, state,  {
               page: action.page
            });
        default:
            return state;
    }
}

const authState = (state = {}, action) => {
    switch (action.type) {
        case 'AUTH_LOADING':
            return Object.assign({}, state, {
                loading: true
            })
        case 'AUTH_FAIL':
            return Object.assign({}, state, {
                loading: false,
                status: 400
            })
        case 'AUTH_CLEAR':
            return {};
        case 'AUTH_CLIENT':
            return Object.assign({}, state,  {
                token: action.token,
                expires: action.expires,
                user: action.user,
                loading: false,
                username: '',
                password: '',
                status: null
            });
        case 'AUTH_FIELD_CHANGE':

            var obj = {};

            switch (action.field) {
                case 'username':
                    obj.username = action.value;
                    break;
                case 'password':
                    obj.password = action.value;
                    break;
            }

            return Object.assign({}, state,  obj);
        default:
            return state;
    }
}

const modelState = (state = {}, action) => {
    switch (action.type) {
        case 'MODELS_LOADING':
            return Object.assign({}, state,  {
                loading: true
            });
        case 'MODELS_RECEIVED':
            return Object.assign({}, state,  {
                loading: false,
                models: action.models,
                orgModels: action.models
            });
        case 'MODEL_SEARCH':
            return Object.assign({}, state,  {
                search: action.search
            });
        case 'MODEL_FILTER':
            return Object.assign({}, state,  {
                models: action.models
            });
        case 'MODEL_FILTER_DISABLE':
            return Object.assign({}, state,  {
                models: state.orgModels
            });
        case 'AUTH_CLEAR':
            return {}
        default:
            return state;
    }
}

const modelSingleState = (state = {}, action) => {
    switch (action.type) {
        case 'MODELS_LOADING':
            return Object.assign({}, state,  {
                loading: true
            });
        case 'MODEL_SET_CURRENT':
            var model = action.model;
            model.loading = false;
            return Object.assign({}, state, model);
        default:
            return state;
    }
}



const profileState = (state = {}, action) => {
    switch (action.type) {
        case 'PROFILE_LOGIN_CHANGE':

            var newObj = {};

            switch (action.field) {
                case 'ssn':
                    newObj.ssn = action.value;
                    break;
                case 'email':
                    newObj.email = action.value;
                    break;
                case 'identity':
                    newObj.identity = action.value;
                    break;
            }

            return Object.assign({}, state, newObj);
        case 'PROFILE_FIELD_CHANGE':

            var newObj = {};

            if (state.profile) {
                newObj =  {...state.profile};
            }

            switch (action.field) {
                case 'ssn':
                    newObj.ssn = action.value;
                    break;
                case 'name':
                    newObj.name = action.value;
                    break;
                case 'email':
                    newObj.email = action.value;
                    break;
                case 'phone':
                    newObj.phone = action.value;
                    break;
                case 'address':
                    newObj.address = action.value;
                    break;
                case 'postal_code':
                    newObj.postal_code = action.value;
                    break;
                case 'city':
                    newObj.city = action.value;
                    break;
                case 'image':
                    newObj.image = action.value;
                    break;
                case 'description':
                    newObj.description = action.value;
                    break;
            }

            return Object.assign({}, state, { profile: newObj});

        case 'PROFILE_RECEIVED':
            return Object.assign({}, state, {
                profile: action.profile,
                ssn: null,
                email: null,
                identity: null
            });
        case 'PROFILE_RECEIVING':
            return Object.assign({}, state, {
                invalid: false,
                status: 0
            });
        case 'PROFILE_RECEIVED_ERROR':
            return Object.assign({}, state, {
                status: action.status
            });
        case 'PROFILE_ERROR_FIELDS':
            return Object.assign({}, state, {
                invalid: true,
                status: 0
            });
        case 'PROFILE_EDIT_MODE':
            return Object.assign({}, state, {
                editMode: !state.editMode
            });
        case 'PROFILE_EDIT_INVALID':
            return Object.assign({}, state,  {
                invalid: true,
                invalidUnknown: false,
                invalidData: action.data
            });
        case 'PROFILE_EDIT_INVALID_UNKNOWN':
            return Object.assign({}, state,  {
                invalidUnknown: true,
                errorCode: action.errorCode
            });
        case 'PROFILE_EDIT_COMPLETE':
            return {...state, editMode: false, invalid: false, invalidData: null, invalidUnknown: false}
        default:
            return state;
    }
}

const contractState = (state = {}, action) => {
    let contract;
    switch (action.type) {
        case 'CONTRACTS_LOADING':
            return Object.assign({}, state,  {
                loading: true
            });
        case 'CONTRACTS_RECEIVED':
            return Object.assign({}, state,  {
                loading: false,
                contracts: action.contracts,
                orgContracts: action.contracts
            });
        case 'CONTRACT_SEARCH':
            return Object.assign({}, state,  {
                search: action.search
            });
        case 'CONTRACT_FILTER':
            return Object.assign({}, state,  {
                filter: action.filter,
                contracts: action.contracts
            });
        case 'CONTRACT_FILTER_DISABLE':
            return Object.assign({}, state,  {
                contracts: state.orgContracts
            });
        case 'CONTRACT_TOGGLE_DELETE':
            return Object.assign({}, state,  {
                deleteToggled: !state.deleteToggled
            });
        case 'CONTRACT_STATUS_CHANGE':

            let orgContracts = [];
            if (state.orgContracts) {
                orgContracts = state.orgContracts;
            }
            const indexOrg = orgContracts.map((contract) => {
                return contract.id;
            }).indexOf(action.id);

            let contracts = state.contracts;
            if (state.contracts) {
                contracts = state.contracts;
            }
            const index = contracts.map((contract) => {
                return contract.id;
            }).indexOf(action.id);

            if (indexOrg >= 0) {
                contract = orgContracts[indexOrg];
                contract.status = action.status;
                orgContracts = orgContracts.slice(0, indexOrg).concat([contract]).concat(orgContracts.slice(indexOrg + 1));
            }

            if (index >= 0) {
                contract = contracts[index];
                contract.status = action.status;
                contracts = contracts.slice(0, index).concat([contract]).concat(contracts.slice(index + 1));
            }

            return Object.assign({}, state,  {
                orgContracts: orgContracts,
                contracts: contracts,
                toggled: null
            });


        case 'CONTRACT_DROPDOWN_TOGGLE':
            return Object.assign({}, state,  {
                toggled: state.toggled === action.id ? 0 : action.id,
                deleteToggled: false
            });
        case 'AUTH_CLEAR':
            return {}
        default:
            return state;
    }
}

const contractSingleState = (state = {}, action) => {
    switch (action.type) {
        case 'CONTRACT_SINGLE_RECEIVED':
            return Object.assign({}, state, action.contract);
        case 'CONTRACT_SINGLE_LOADING':
            return Object.assign({}, state, {
                id: 0
            });
        case 'CONTRACT_STATUS_LOADING':
            return Object.assign({}, state, {
                loadingStatus: true
            });
        case 'CONTRACT_STATUS_CHANGE':
            return Object.assign({}, state, {
                status: action.status,
                loadingStatus: false
            });
            break;
        case 'AUTH_CLEAR':
            return {}
        default:
            return state;
    }
}

const eventState = (state = {}, action) => {
    switch (action.type) {
        case 'EVENTS_LOADING':
            return Object.assign({}, state,  {
                loading: true
            });
        case 'EVENTS_RECEIVED':
            return Object.assign({}, state,  {
                loading: false,
                events: action.events,
                orgEvents: action.events,
                search: '',
                toggled: 0
            });
        case 'EVENTS_SEARCH':
            return Object.assign({}, state,  {
                search: action.search
            });
        case 'EVENT_TOGGLE_DELETE':
            return Object.assign({}, state,  {
                deleteToggled: !state.deleteToggled
            });
        case 'EVENT_DELETE':

            var orgEvents = [];
            if (state.orgEvents) {
                orgEvents = state.orgEvents;
            }
            var indexOrg = orgEvents.map((event) => {
                return event.id;
            }).indexOf(action.id)

            if (indexOrg >= 0) {
                orgEvents = orgEvents.slice(0, indexOrg).concat(orgEvents.slice(indexOrg + 1));
            }

            var events = [];
            if (state.events) {
                events = state.events;
            }
            var index = events.map((event) => {
                return event.id;
            }).indexOf(action.id)

            if (index >= 0) {
                events = events.slice(0, index).concat(events.slice(index + 1));
            }

            return Object.assign({}, state,  {
                events: events,
                orgEvents: orgEvents
            });

        case 'EVENTS_FILTER':
            return Object.assign({}, state,  {
                events: action.events
            });
        case 'EVENTS_FILTER_DISABLE':
            return Object.assign({}, state,  {
                events: state.orgEvents
            });
        case 'EVENT_DROPDOWN_TOGGLE':
            return Object.assign({}, state,  {
                toggled: state.toggled === action.id ? 0 : action.id,
                deleteToggled: false
            });
        case 'SET_PAGE':
            return Object.assign({}, state,  {
                toggled: 0,
                deleteToggled: false
            });
        case 'AUTH_CLEAR':
            return {}
        default:
            return state;
    }
}

const eventFormState = (state = {}, action) => {
    switch (action.type) {
        case 'EVENT_FIELD_CHANGE':

            var obj = {};

            if (state.fields) {
                obj = Object.assign({}, state.fields);
            }

            obj[action.field] = action.value;

            return Object.assign({}, state, {
                fields: obj
            });
        case 'EVENT_FORM_SET':
            return Object.assign({}, state, {
                status: 0,
                saved: false,
                fields: action.event
            });

        case 'EVENT_FORM_CREATED':
            return Object.assign({}, state, {
                saved: true,
                status: 0,
                fields: {

                }
            });
        case 'EVENT_FORM_ERROR':
            return Object.assign({}, state, {
                status: action.status
            });
        case 'EVENT_FORM_RESET':
            return Object.assign({}, state, {
                status: 0,
                saved: false,
                fields: {
                    eula: action.eula,
                    validYears: action.validYears
                }
            });
        case 'AUTH_CLEAR':
            return {}
        default:
            return state;
    }
}

export const store = configureStore({
    reducer: {
        registerState,
        pageState,
        authState,
        modelState,
        modelSingleState,
        eventState,
        contractState,
        contractSingleState,
        registerModelState,
        sinceState,
        profileState,
        eventFormState
    },
    devTools: process.env.NODE_ENV === 'development',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false
    })
});